import { Box, Typography } from '@mui/material';
import ChartSection from '../shared/ChartSection';
import { fmtPct, fmtDate } from '../shared/formatters';

export default function TopSingleTrades({ data }) {
    if (!data || data.length === 0) return null;

    return (
        <ChartSection id="top-trades" title="The 10 greatest single trades in Congress" subtitle="Individual stock purchases with the highest alpha vs S&P 500" takeaway={data.length > 0 ? `The single best congressional trade generated ${fmtPct(data[0].alpha)} alpha over the S\u00a0&\u00a0P 500 — the kind of return that raises serious questions about timing and information access.` : null}>
            {data.map((t, i) => (
                <Box key={i} sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    py: 1, borderBottom: i < data.length - 1 ? th => '1px solid ' + th.palette.custom.border.subtle : 'none',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography sx={{ fontFamily: t2 => t2.typography.fontFamilyMono, color: 'text.muted', width: 24, textAlign: 'right' }}>
                            {i + 1}.
                        </Typography>
                        <Box>
                            <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 600 }}>
                                {t.name} — {t.ticker}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.muted' }}>
                                {fmtDate(t.date)} · {t.sector}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography sx={{ fontFamily: t2 => t2.typography.fontFamilyMono, fontWeight: 700, color: 'success.main' }}>
                            {fmtPct(t.alpha)} alpha
                        </Typography>
                        <Typography variant="caption" sx={{ fontFamily: t2 => t2.typography.fontFamilyMono, color: 'text.muted' }}>
                            {fmtPct(t.roi)} return
                        </Typography>
                    </Box>
                </Box>
            ))}
        </ChartSection>
    );
}
